var _defs, _polyline, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPHeatingBranchValve = function SvgPHeatingBranchValve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684.2 480.2"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "342.1 46.1 342.1 55.1 653.1 55.1 653.1 71.1",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "2px",
    stroke: "#1c9d5b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 632.1,
    y1: 96.1,
    x2: 632.1,
    y2: 68.1,
    fill: "none",
    strokeMiterlimit: 10,
    stroke: "#fff",
    strokeWidth: "10px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 642.1,
    y1: 82.1,
    x2: 632.1,
    y2: 82.1,
    stroke: "#000",
    fill: "none",
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "625 95.6 632.1 83.1 639.2 95.6 625 95.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.1,84.1l6.3,11h-12.5l6.2-11M632.1,82.1l-8,14h16l-8-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "625 68.6 639.2 68.6 632.1 81.1 625 68.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.8,69.1h12.5l-6.3,11-6.2-11M624.1,68.1l8,14,8-14h-16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M653.1,92.6c-5.8,0-10.5-4.7-10.5-10.5s4.7-10.5,10.5-10.5,10.5,4.7,10.5,10.5-4.7,10.5-10.5,10.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.1,72.1c5.5,0,10,4.5,10,10s-4.5,10-10,10-10-4.5-10-10,4.5-10,10-10M653.1,71.1c-6.1,0-11,4.9-11,11s4.9,11,11,11,11-4.9,11-11-4.9-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M652,79.2l1.6,4.4,1.6-4.4h1.3v5.7h-1v-1.9l.1-2.5-1.7,4.4h-.7l-1.7-4.4.1,2.5v1.9h-1v-5.7h1.4Z"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 642.1,
    y1: 110.1,
    x2: 636.6,
    y2: 110.1,
    stroke: "#000",
    fill: "none",
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 624.6,
    y: 96.6,
    width: 15,
    height: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.1,97.1v2h-14v-2h14M640.1,96.1h-16v4h16v-4h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 624.6,
    y: 120.6,
    width: 15,
    height: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.1,121.1v2h-14v-2h14M640.1,120.1h-16v4h16v-4h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 627.6,
    y: 99.6,
    width: 9,
    height: 21,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.1,100.1v20h-8v-20h8M637.1,99.1h-10v22h10v-22h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M636.7,120.1c-1.8-2.6-2.8-6.4-2.8-9.9s1-7.3,2.8-9.9",
    stroke: "#000",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.5,120.1c1.8-2.6,2.8-6.4,2.8-9.9s-1-7.3-2.8-9.9",
    stroke: "#000",
    fill: "none",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 642.6,
    y: 99.6,
    width: 21,
    height: 21,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.1,100.1v20h-20v-20h20M664.1,99.1h-22v22h22v-22h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M654.5,107.1h1.1l-2,5.7h-1l-2-5.7h1.1l1.5,4.4,1.3-4.4h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 653.1,
    y1: 99.1,
    x2: 653.1,
    y2: 93.1,
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 658.1,
    y1: 131.1,
    x2: 658.1,
    y2: 125.6,
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "659.5 126.5 658.1 121.1 656.6 126.6 659.5 126.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 648.1,
    y1: 131.1,
    x2: 648.1,
    y2: 125.6,
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "649.5 126.5 648.1 121.1 646.6 126.6 649.5 126.5"
  })))));
};
export default SvgPHeatingBranchValve;